/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseReservations
 */
export interface GetConfig200ResponseReservations {
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseReservations
     */
    dinersLimit: number | null;
}

/**
 * Check if a given object implements the GetConfig200ResponseReservations interface.
 */
export function instanceOfGetConfig200ResponseReservations(value: object): value is GetConfig200ResponseReservations {
    if (!('dinersLimit' in value) || value['dinersLimit'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseReservationsFromJSON(json: any): GetConfig200ResponseReservations {
    return GetConfig200ResponseReservationsFromJSONTyped(json, false);
}

export function GetConfig200ResponseReservationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseReservations {
    if (json == null) {
        return json;
    }
    return {
        
        'dinersLimit': json['dinersLimit'],
    };
}

export function GetConfig200ResponseReservationsToJSON(json: any): GetConfig200ResponseReservations {
    return GetConfig200ResponseReservationsToJSONTyped(json, false);
}

export function GetConfig200ResponseReservationsToJSONTyped(value?: GetConfig200ResponseReservations | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dinersLimit': value['dinersLimit'],
    };
}

